const CANADIAN_POSTAL_CODE_REGEX = /[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d/;
const US_ZIP_CODE_REGEX = /\b\d{5}(?:-\d{4})?\b/;

const normalizeCanadianPostalCode = (value: string): string => {
  const compactPostal = value.replace(/\s+/g, '').toUpperCase();
  return `${compactPostal.slice(0, 3)} ${compactPostal.slice(3)}`;
};

export const extractPostalCodeFromText = (
  value: string,
): string | undefined => {
  const canadianPostalMatch = value.match(CANADIAN_POSTAL_CODE_REGEX);
  if (canadianPostalMatch) {
    return normalizeCanadianPostalCode(canadianPostalMatch[0]);
  }

  const usZipMatch = value.match(US_ZIP_CODE_REGEX);
  if (usZipMatch) return usZipMatch[0];

  return undefined;
};

export const isCompletePostalCode = (postalCode?: string): boolean => {
  if (!postalCode) return false;

  return (
    CANADIAN_POSTAL_CODE_REGEX.test(postalCode) ||
    US_ZIP_CODE_REGEX.test(postalCode)
  );
};
